module.exports = __webpack_public_path__ + "static/media/bss-mcq.caea6e80.pdf";